import {MapNode, NodeType} from 'common/src/modules/nodes/nodes.types';
import {
  ContentFeedNode,
  DTCampaignNode,
  DTCompoundConditionNode,
  DTConditionNode,
  DTCreativeNode,
  DTDistributionNode,
  DTNativeCreativeNode,
  DTOptimizationNode,
  DTProductSelectionNode,
  DTScheduleNode,
  DTSequenceNode,
  DTStoreNode,
  DTWeightedNode,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {campaignCardToText} from './campaignCardToText';
import {conditionCardToText} from './conditionCardToText';
import {contentCardToText} from './contentCardToText';
import {creativeCardToText} from './creativeCardToText';
import {distributionCardToText} from './distributionCardToText';
import {locationCardToText} from './locationCardToText';
import {nativeCreativeCardToText} from './nativeCreativeCardToText';
import {optimizationCardToText} from './optimizationCardToText';
import {productCardToText} from './productCardToText';
import {scheduleCardToText} from './scheduleCardToText';
import {sequenceCardToText} from './sequenceCardToText';
import {weightedCardToText} from './weightedCardToText';
import {compoundConditionCardToText} from './compoundConditionCardToText';

export type TextMode = 'short' | 'full';

export function cardToText(
  card: MapNode,
  mode: TextMode,
  fallbackCreativeNodeId?: number,
): string | null {
  switch (card.type) {
    case NodeType.CAMPAIGN:
      return campaignCardToText(card as DTCampaignNode, mode, fallbackCreativeNodeId);
    case NodeType.CONDITION:
      return conditionCardToText(card as DTConditionNode, mode, fallbackCreativeNodeId);
    case NodeType.COMPOUND_CONDITION:
      return compoundConditionCardToText(
        card as DTCompoundConditionNode,
        mode,
        fallbackCreativeNodeId,
      );
    case NodeType.CONTENT_FEED:
      return contentCardToText(card as ContentFeedNode, mode, fallbackCreativeNodeId);
    case NodeType.CREATIVE:
    case NodeType.CONCEPT_CREATIVE:
      return creativeCardToText(card as DTCreativeNode, mode, fallbackCreativeNodeId);
    case NodeType.DISTRIBUTION:
      return distributionCardToText(card as DTDistributionNode, mode, fallbackCreativeNodeId);
    case NodeType.STORE:
      return locationCardToText(card as DTStoreNode, mode, fallbackCreativeNodeId);
    case NodeType.GENERAL_OPTIMIZATION:
      return optimizationCardToText(card as DTOptimizationNode, mode, fallbackCreativeNodeId);
    case NodeType.PRODUCTS:
      return productCardToText(card as DTProductSelectionNode, mode, fallbackCreativeNodeId);
    case NodeType.SCHEDULE:
      return scheduleCardToText(card as DTScheduleNode, mode, fallbackCreativeNodeId);
    case NodeType.SEQUENCE:
      return sequenceCardToText(card as DTSequenceNode, mode, fallbackCreativeNodeId);
    case NodeType.WEIGHTED:
      return weightedCardToText(card as DTWeightedNode, mode, fallbackCreativeNodeId);
    case NodeType.NATIVE_CREATIVE:
      return nativeCreativeCardToText(card as DTNativeCreativeNode, mode, fallbackCreativeNodeId);
    default:
      return null;
  }
}

export {campaignCardToText} from './campaignCardToText';
export {conditionCardToText} from './conditionCardToText';
export {contentCardToText} from './contentCardToText';
export {creativeCardToText} from './creativeCardToText';
export {distributionCardToText} from './distributionCardToText';
export {locationCardToText} from './locationCardToText';
export {nativeCreativeCardToText} from './nativeCreativeCardToText';
export {optimizationCardToText} from './optimizationCardToText';
export {productCardToText} from './productCardToText';
export {scheduleCardToText} from './scheduleCardToText';
export {sequenceCardToText} from './sequenceCardToText';
export {weightedCardToText} from './weightedCardToText';
export {
  findFallbackCreativeNodeId,
  formatFallbackOutputLine,
  formatOutputHeader,
  formatShortOutputLine,
  getBaseHeader,
  getDestinationPhrase,
  getOutputIdentifier,
  getOutputTypePhrase,
  sortOutputsByType,
} from './utils';
